var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        { attrs: { id: "tab-hbl2" } },
        [
          _c("div", { staticClass: "section operations" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.cooperateEdit,
                    expression: "cooperateEdit"
                  }
                ],
                staticClass: "triggers"
              },
              [
                _c(
                  "div",
                  [
                    _c(
                      "el-dropdown",
                      {
                        class: _vm.readonly ? "not-click" : "",
                        attrs: {
                          no: "command1",
                          "split-button": "",
                          type: "primary"
                        },
                        on: {
                          click: function($event) {
                            return _vm.commandHandle(_vm.command1)
                          },
                          command: function(p) {
                            _vm.command1 = p
                            _vm.commandHandle(_vm.command1)
                          }
                        }
                      },
                      [
                        _vm._v(" " + _vm._s(_vm.command1) + " "),
                        _c(
                          "el-dropdown-menu",
                          { attrs: { slot: "dropdown" }, slot: "dropdown" },
                          [
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: _vm.$t("SeaExport.CodeSearching")
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.CodeSearching"))
                                )
                              ]
                            ),
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: _vm.$t(
                                    "SeaExport.CopyFromTheLastTime"
                                  )
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SeaExport.CopyFromTheLastTime")
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: _vm.$t("SeaExport.CopyFromOtherBill")
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.CopyFromOtherBill"))
                                )
                              ]
                            ),
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: _vm.$t(
                                    "SeaExport.CopyCargoDescriptionAndMarks"
                                  )
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "SeaExport.CopyCargoDescriptionAndMarks"
                                    )
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: Boolean(_vm.form.docType),
                            expression: "Boolean(form.docType)"
                          }
                        ],
                        attrs: {
                          no: "originalPrint",
                          disabled: _vm.btnPrintDisabled,
                          type: "primary"
                        },
                        on: { click: _vm.originalPrint }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.form.releaseType === 1
                              ? _vm.$t("SeaExport.PrintTheOriginalBl")
                              : _vm.$t("SeaExport.TelexRelease")
                          )
                        )
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.form.state == 2,
                            expression: "form.state==2"
                          }
                        ],
                        attrs: { no: "onSubmitStatEvent", type: "primary" },
                        on: { click: _vm.unlock }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Unlock")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          no: "showAddressFormatDialog",
                          disabled: _vm.readonly || !_vm.form.uuid,
                          type: "primary"
                        },
                        on: { click: _vm.showAddressFormatDialog }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("SeaExport.AntiTerroristFormattedAddress")
                          )
                        )
                      ]
                    ),
                    !_vm.OpenXHQDocumentCenter
                      ? _c(
                          "el-dropdown",
                          {
                            class: _vm.btnBLConfirmDisabled ? "not-click" : "",
                            staticStyle: { "padding-left": "5px" },
                            attrs: {
                              no: "command2",
                              "split-button": "",
                              type: "primary"
                            },
                            on: {
                              click: function($event) {
                                return _vm.commandHandle(_vm.command2)
                              },
                              command: function(p) {
                                _vm.command2 = p
                                _vm.commandHandle(_vm.command2)
                              }
                            }
                          },
                          [
                            _vm._v(" " + _vm._s(_vm.command2) + " "),
                            _c(
                              "el-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              [
                                _c(
                                  "el-dropdown-item",
                                  {
                                    attrs: {
                                      command: _vm.$t(
                                        "SeaExport.InviteToChecktheBL"
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.InviteToChecktheBL")
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "el-dropdown-item",
                                  {
                                    directives: [
                                      {
                                        name: "permission",
                                        rawName: "v-permission",
                                        value: ["button_M/HBL_confirmBL"],
                                        expression: "['button_M/HBL_confirmBL']"
                                      }
                                    ],
                                    attrs: {
                                      command: _vm.$t(
                                        "SeaExport.ConfirmChecking"
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.ConfirmChecking")
                                      )
                                    )
                                  ]
                                ),
                                _vm.$checkPermission([
                                  "button_M/HBL_identification"
                                ])
                                  ? _c(
                                      "el-dropdown-item",
                                      {
                                        attrs: {
                                          command: _vm.$t(
                                            "SeaExport.IdentificationList"
                                          )
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "SeaExport.IdentificationList"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "el-dropdown-item",
                                  {
                                    attrs: {
                                      command: _vm.$t(
                                        "SeaExport.CheckingHistory"
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.CheckingHistory")
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "el-dropdown-item",
                                  {
                                    attrs: {
                                      command: _vm.$t(
                                        "SeaExport.UploadGuarantee"
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.UploadGuarantee")
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.OpenXHQDocumentCenter
                      ? _c(
                          "el-menu",
                          {
                            staticClass:
                              "el-menu-button el-button el-button--primary el-button--mini",
                            class:
                              _vm.isEdit || !_vm.form.uuid
                                ? "is-disabled not-click"
                                : "",
                            staticStyle: { "vertical-align": "top" },
                            attrs: {
                              "text-color": "#404144",
                              "active-text-color": "#404144",
                              mode: "horizontal"
                            },
                            on: { select: _vm.XHQDocumentCenterSelectHandler }
                          },
                          [
                            _c(
                              "el-submenu",
                              { attrs: { index: "index" } },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "el-menu-btn-text",
                                    attrs: { slot: "title" },
                                    slot: "title"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.InviteToChecktheBL")
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "el-menu-item",
                                  { attrs: { index: "InviteToChecktheBL" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.InviteToChecktheBL")
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "el-submenu",
                                  {
                                    attrs: {
                                      index: _vm.$t(
                                        "SeaExport.UploadCustomerFiles"
                                      )
                                    }
                                  },
                                  [
                                    _c("template", { slot: "title" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "SeaExport.UploadCustomerFiles"
                                          )
                                        )
                                      )
                                    ]),
                                    _c(
                                      "el-menu-item",
                                      {
                                        attrs: {
                                          index:
                                            "BillOfLadingConfirmationDocument"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "Clearing.BillOfLadingConfirmationDocument"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-menu-item",
                                      {
                                        attrs: {
                                          index: "CustomerSelfIssuedFiles"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "SeaExport.CustomerSelfIssuedFiles"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _vm.ToExoSystemJYD
                                      ? _c(
                                          "el-menu-item",
                                          {
                                            attrs: {
                                              index: "OriginBillOfLading"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "SeaExport.OriginBillOfLading"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "el-menu-item",
                                      { attrs: { index: "ShippingOrder" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("SeaExport.ShippingOrder")
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  2
                                ),
                                _vm.$checkPermission([
                                  "button_M/HBL_identification"
                                ])
                                  ? _c(
                                      "el-menu-item",
                                      {
                                        attrs: { index: "IdentificationList" }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "SeaExport.IdentificationList"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "el-menu-item",
                                  { attrs: { index: "CheckTheBLLog" } },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SeaExport.CheckTheBLLog"))
                                    )
                                  ]
                                ),
                                _c(
                                  "el-menu-item",
                                  { attrs: { index: "ConfirmChecking" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.ConfirmChecking")
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "el-menu-item",
                                  { attrs: { index: "UploadGuarantee" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.UploadGuarantee")
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.OpenXHQDocumentCenter && _vm.ToExoSystemJYD
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              disabled: _vm.isEdit || !_vm.form.uuid,
                              no: "CustomerToOrder",
                              type: "primary"
                            },
                            on: {
                              click: function($event) {
                                return _vm.onOpenDocLink(0)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.CustomerToOrder")))]
                        )
                      : _vm._e(),
                    _vm.OpenXHQDocumentCenter && _vm.ToExoSystemJYD
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              disabled: _vm.isEdit || !_vm.form.uuid,
                              no: "DesignatedGoodsToBillOfLading",
                              type: "primary"
                            },
                            on: {
                              click: function($event) {
                                return _vm.onOpenDocLink(1)
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "SeaExport.DesignatedGoodsToBillOfLading"
                                )
                              )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm.OpenXHQDocumentCenter
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              disabled: _vm.isEdit,
                              no: "updateBillInfo",
                              type: "primary"
                            },
                            on: {
                              click: function($event) {
                                return _vm.pm.updateBillInfo()
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("SeaExport.ConfirmationBillOfLading")
                              )
                            )
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { "margin-left": "20px" },
                        attrs: { value: _vm.form.state === 2, disabled: true }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Locked")))]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { "margin-left": "-20px" },
                        attrs: { no: "oversea", disabled: _vm.readonly },
                        model: {
                          value: _vm.form.oversea,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "oversea", $$v)
                          },
                          expression: "form.oversea"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.BlBeReleased")))]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { "margin-left": "-20px" },
                        attrs: { no: "printParam1", disabled: _vm.readonly },
                        on: {
                          change: function($event) {
                            return _vm.pm.changeSeaeq()
                          }
                        },
                        model: {
                          value: _vm.form.printParam1,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "printParam1", $$v)
                          },
                          expression: "form.printParam1"
                        }
                      },
                      [_vm._v("Part of")]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { "margin-left": "-20px" },
                        attrs: { no: "printParam2", disabled: _vm.readonly },
                        model: {
                          value: _vm.form.printParam2,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "printParam2", $$v)
                          },
                          expression: "form.printParam2"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("SeaExport.ClauseOfNoWoodPackingMaterial")
                          )
                        )
                      ]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { "margin-left": "-20px" },
                        attrs: { no: "printParam3", disabled: _vm.readonly },
                        on: {
                          change: function(val) {
                            _vm.pm.changeContainer(val)
                          }
                        },
                        model: {
                          value: _vm.form.printParam3,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "printParam3", $$v)
                          },
                          expression: "form.printParam3"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "SeaExport.ShowNumberOfPackagesGrossWeightAndMeasurementAfterCNTRNOSSEALNOS"
                            )
                          )
                        )
                      ]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { "margin-left": "-20px" },
                        attrs: { disabled: _vm.readonly },
                        model: {
                          value: _vm.chkConsolidationClosed,
                          callback: function($$v) {
                            _vm.chkConsolidationClosed = $$v
                          },
                          expression: "chkConsolidationClosed"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.AFRTheLastBill")))]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        attrs: {
                          no: "customerSelfRelease",
                          value: _vm.form.customerSelfRelease === 1,
                          disabled: _vm.readonly
                        },
                        on: { input: _vm.isCustomerSelfRelease }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.CustomerSelfRelease")))]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        attrs: {
                          no: "customerSelfRelease2",
                          value: _vm.form.customerSelfRelease === 2,
                          disabled: _vm.readonly
                        },
                        on: { input: _vm.isCompanySelfRelease }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.CompanySelfRelease")))]
                    )
                  ],
                  1
                )
              ]
            )
          ]),
          _c(
            "div",
            { staticStyle: { width: "fit-content" } },
            [
              _c(
                "tab-HBL2-UICustom-layout",
                { attrs: { "element-blocks": _vm.elementBlocks } },
                [
                  _vm.elementDict.shipper.viewable
                    ? _c(
                        "template",
                        { slot: "shipper" },
                        [
                          _c(
                            "el-form-item",
                            { staticClass: "auto-width" },
                            [
                              _c(
                                "template",
                                { slot: "label" },
                                [
                                  _c("line-label", {
                                    class:
                                      (_vm.elementDict.shipper.isRequire
                                        ? "blue "
                                        : "") + _vm.variableCss.shipperLine,
                                    attrs: {
                                      label: _vm.elementDict.shipper.label
                                    }
                                  }),
                                  _c("char-count", {
                                    staticStyle: {
                                      position: "static",
                                      display: "block",
                                      "font-size": "10px",
                                      color: "#909399"
                                    },
                                    attrs: { form: _vm.form, prefix: "shipper" }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticStyle: { display: "flex" } },
                                [
                                  _c("el-input", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                        expression:
                                          "!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                      }
                                    ],
                                    ref: "shipperCode",
                                    staticStyle: { flex: "1" },
                                    attrs: {
                                      disabled:
                                        _vm.readonly ||
                                        !_vm.elementDict.shipper.writable,
                                      no: "shipperCode"
                                    },
                                    model: {
                                      value: _vm.form.shipperCode,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "shipperCode", $$v)
                                      },
                                      expression: "form.shipperCode"
                                    }
                                  }),
                                  _c("cargo-advance-select", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                        expression:
                                          "synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                      }
                                    ],
                                    staticStyle: { flex: "1" },
                                    attrs: {
                                      disabled:
                                        _vm.readonly ||
                                        !_vm.elementDict.shipper.writable,
                                      no: "shipperId",
                                      "select-type":
                                        _vm.selectTypeNames.basic_data_Company,
                                      headers: [_vm.$t("Partners.englishName")],
                                      fields: ["englishName"],
                                      "method-params": {
                                        shipper: true,
                                        active: true
                                      },
                                      filterable: "",
                                      "default-value": _vm.form.shipperId || "",
                                      "tag-name": "englishName"
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        _vm.pm.shipperAutoCompleteChange(p)
                                      }
                                    }
                                  }),
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: { "margin-left": "6px" },
                                      attrs: {
                                        type: "primary",
                                        disabled:
                                          _vm.readonly ||
                                          !_vm.elementDict.shipper.writable
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.pm.onClear(1)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")))]
                                  )
                                ],
                                1
                              )
                            ],
                            2
                          ),
                          _vm._l(7, function(count) {
                            return _c(
                              "el-form-item",
                              {
                                key: "shipperLine" + count,
                                class:
                                  "auto-width " +
                                  _vm.getClass("shipperLine", count)
                              },
                              [
                                _c("cargo-input", {
                                  ref: "shipperLine" + count,
                                  refInFor: true,
                                  attrs: {
                                    disabled:
                                      _vm.readonly ||
                                      !_vm.elementDict.shipper.writable,
                                    no: "shipperLine" + count,
                                    "auto-uppercase":
                                      _vm.notUppercaseShipperConsigneNotify,
                                    "use-read-only": true
                                  },
                                  on: {
                                    change: function() {
                                      return _vm.wrapAddr(
                                        _vm.form,
                                        "shipperLine" + count,
                                        count + 1 > 6
                                          ? null
                                          : "shipperLine" + (count + 1),
                                        _vm.maxChars
                                      )
                                    }
                                  },
                                  nativeOn: {
                                    dblclick: function($event) {
                                      return _vm.showShipperDialog($event)
                                    }
                                  },
                                  model: {
                                    value: _vm.form["shipperLine" + count],
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "shipperLine" + count,
                                        $$v
                                      )
                                    },
                                    expression: "form['shipperLine'+count]"
                                  }
                                })
                              ],
                              1
                            )
                          })
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.elementDict.consignee.viewable
                    ? _c(
                        "template",
                        { slot: "consignee" },
                        [
                          _c(
                            "el-form-item",
                            { staticClass: "auto-width" },
                            [
                              _c(
                                "template",
                                { slot: "label" },
                                [
                                  _c("line-label", {
                                    class:
                                      (_vm.elementDict.consignee.isRequire
                                        ? "blue "
                                        : "") + _vm.variableCss.consigneeLine,
                                    attrs: {
                                      label: _vm.elementDict.consignee.label
                                    }
                                  }),
                                  _c("char-count", {
                                    staticStyle: {
                                      position: "static",
                                      display: "block",
                                      "font-size": "10px",
                                      color: "#909399"
                                    },
                                    attrs: {
                                      form: _vm.form,
                                      prefix: "consignee"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticStyle: { display: "flex" } },
                                [
                                  _c("el-input", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                        expression:
                                          "!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                      }
                                    ],
                                    ref: "consigneeCode",
                                    staticStyle: { flex: "1" },
                                    attrs: {
                                      disabled:
                                        _vm.readonly ||
                                        !_vm.elementDict.consignee.writable,
                                      no: "consigneeCode"
                                    },
                                    model: {
                                      value: _vm.form.consigneeCode,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "consigneeCode", $$v)
                                      },
                                      expression: "form.consigneeCode"
                                    }
                                  }),
                                  _c("cargo-advance-select", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                        expression:
                                          "synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                      }
                                    ],
                                    staticStyle: { flex: "1" },
                                    attrs: {
                                      disabled:
                                        _vm.readonly ||
                                        !_vm.elementDict.consignee.writable,
                                      no: "consigneeId",
                                      "select-type":
                                        _vm.selectTypeNames.basic_data_Company,
                                      headers: [_vm.$t("Partners.englishName")],
                                      fields: ["englishName"],
                                      "method-params": {
                                        consignee: true,
                                        active: true
                                      },
                                      filterable: "",
                                      "default-value":
                                        _vm.form.consigneeId || "",
                                      "tag-name": "englishName"
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        _vm.pm.consigneeAutoCompleteChange(p)
                                      }
                                    }
                                  }),
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: { "margin-left": "6px" },
                                      attrs: {
                                        no: "onClear2",
                                        type: "primary",
                                        disabled:
                                          _vm.readonly ||
                                          !_vm.elementDict.consignee.writable
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.pm.onClear(2)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")))]
                                  )
                                ],
                                1
                              )
                            ],
                            2
                          ),
                          _vm._l(7, function(count) {
                            return _c(
                              "el-form-item",
                              {
                                key: "consigneeLine" + count,
                                class:
                                  "auto-width " +
                                  _vm.getClass("consigneeLine", count)
                              },
                              [
                                _c("cargo-input", {
                                  ref: "consigneeLine" + count,
                                  refInFor: true,
                                  attrs: {
                                    disabled:
                                      _vm.readonly ||
                                      !_vm.elementDict.consignee.writable,
                                    no: "consigneeLine" + count,
                                    "auto-uppercase":
                                      _vm.notUppercaseShipperConsigneNotify,
                                    "use-read-only": true
                                  },
                                  on: {
                                    change: function() {
                                      return _vm.wrapAddr(
                                        _vm.form,
                                        "consigneeLine" + count,
                                        count + 1 > 6
                                          ? null
                                          : "consigneeLine" + (count + 1),
                                        _vm.maxChars
                                      )
                                    }
                                  },
                                  nativeOn: {
                                    dblclick: function($event) {
                                      return _vm.showConsigneeDialog($event)
                                    }
                                  },
                                  model: {
                                    value: _vm.form["consigneeLine" + count],
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "consigneeLine" + count,
                                        $$v
                                      )
                                    },
                                    expression: "form['consigneeLine'+count]"
                                  }
                                })
                              ],
                              1
                            )
                          })
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.elementDict.notify.viewable
                    ? _c(
                        "template",
                        { slot: "notify" },
                        [
                          _c(
                            "el-form-item",
                            { staticClass: "auto-width" },
                            [
                              _c(
                                "template",
                                { slot: "label" },
                                [
                                  _c("line-label", {
                                    class: _vm.elementDict.notify.isRequire
                                      ? "blue"
                                      : "",
                                    attrs: {
                                      label: _vm.elementDict.notify.label
                                    }
                                  }),
                                  _c("char-count", {
                                    staticStyle: {
                                      position: "static",
                                      display: "block",
                                      "font-size": "10px",
                                      color: "#909399"
                                    },
                                    attrs: { form: _vm.form, prefix: "notify" }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                [
                                  _c("el-input", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                        expression:
                                          "!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                      }
                                    ],
                                    ref: "notifyCode",
                                    attrs: {
                                      disabled:
                                        _vm.readonly ||
                                        !_vm.elementDict.notify.writable,
                                      no: "notifyCode"
                                    },
                                    model: {
                                      value: _vm.form.notifyCode,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "notifyCode", $$v)
                                      },
                                      expression: "form.notifyCode"
                                    }
                                  }),
                                  _c("cargo-advance-select", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                        expression:
                                          "synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                      }
                                    ],
                                    attrs: {
                                      disabled:
                                        _vm.readonly ||
                                        !_vm.elementDict.notify.writable,
                                      no: "notifyId",
                                      "select-type":
                                        _vm.selectTypeNames.basic_data_Company,
                                      headers: [_vm.$t("Partners.englishName")],
                                      fields: ["englishName"],
                                      "method-params": {
                                        notify: true,
                                        active: true
                                      },
                                      filterable: "",
                                      "default-value": _vm.form.notifyId || "",
                                      "tag-name": "englishName"
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        _vm.pm.notifyAutoCompleteChange(p)
                                      }
                                    }
                                  }),
                                  _c(
                                    "div",
                                    { staticStyle: { "margin-top": "5px" } },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticStyle: { "min-width": "50px" },
                                          attrs: {
                                            no: "onClear3",
                                            type: "primary",
                                            disabled:
                                              _vm.readonly ||
                                              !_vm.elementDict.notify.writable
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.pm.onClear(3)
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("SeaExport.Reset"))
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          staticStyle: { "margin-left": "5px" },
                                          attrs: {
                                            no: "onCopy_consignee",
                                            type: "primary",
                                            disabled:
                                              _vm.readonly ||
                                              !_vm.elementDict.notify.writable
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.pm.onCopy_consignee()
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "SeaExport.CopyTheConsignee"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            2
                          ),
                          _vm._l(7, function(count) {
                            return _c(
                              "el-form-item",
                              {
                                key: "notifyLine" + count,
                                class:
                                  "auto-width " +
                                  _vm.getClass("notifyLine", count)
                              },
                              [
                                _c("cargo-input", {
                                  ref: "notifyLine" + count,
                                  refInFor: true,
                                  attrs: {
                                    disabled:
                                      _vm.readonly ||
                                      !_vm.elementDict.notify.writable,
                                    no: "notifyLine" + count,
                                    "auto-uppercase":
                                      _vm.notUppercaseShipperConsigneNotify,
                                    "use-read-only": true
                                  },
                                  on: {
                                    change: function() {
                                      return _vm.wrapAddr(
                                        _vm.form,
                                        "notifyLine" + count,
                                        count + 1 > 6
                                          ? null
                                          : "notifyLine" + (count + 1),
                                        _vm.maxChars
                                      )
                                    }
                                  },
                                  nativeOn: {
                                    dblclick: function($event) {
                                      return _vm.showNotifyDialog($event)
                                    }
                                  },
                                  model: {
                                    value: _vm.form["notifyLine" + count],
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "notifyLine" + count,
                                        $$v
                                      )
                                    },
                                    expression: "form['notifyLine'+count]"
                                  }
                                })
                              ],
                              1
                            )
                          })
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.elementDict.alsoNotify.viewable
                    ? _c(
                        "template",
                        { slot: "agentParty" },
                        [
                          _c(
                            "el-form-item",
                            { staticClass: "auto-width" },
                            [
                              _c("line-label", {
                                class: _vm.elementDict.agentParty.isRequire
                                  ? "blue"
                                  : "",
                                style: _vm.elementDict.agentParty.isRequire
                                  ? ""
                                  : "color:#404144!important;",
                                attrs: {
                                  slot: "label",
                                  label: _vm.elementDict.agentParty.label
                                },
                                slot: "label"
                              }),
                              _c(
                                "div",
                                { staticStyle: { "text-align": "right" } },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: {
                                        "min-width": "50px",
                                        "margin-right": "5px"
                                      },
                                      attrs: {
                                        no: "onClear4",
                                        type: "primary",
                                        disabled:
                                          _vm.readonly ||
                                          !_vm.elementDict.agentParty.writable
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.pm.onClear(4)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")))]
                                  ),
                                  _c(
                                    "el-dropdown",
                                    {
                                      class: _vm.readonly ? "not-click" : "",
                                      staticStyle: { "margin-top": "5px" },
                                      attrs: {
                                        no: "command3",
                                        disabled:
                                          _vm.readonly ||
                                          !_vm.elementDict.agentParty.writable,
                                        "split-button": "",
                                        type: "primary"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.commandHandle(_vm.command3)
                                        },
                                        command: function(p) {
                                          _vm.command3 = p
                                          _vm.commandHandle(_vm.command3)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(" " + _vm._s(_vm.command3) + " "),
                                      _c(
                                        "el-dropdown-menu",
                                        {
                                          attrs: { slot: "dropdown" },
                                          slot: "dropdown"
                                        },
                                        [
                                          _c(
                                            "el-dropdown-item",
                                            {
                                              attrs: {
                                                command: _vm.$t(
                                                  "SeaExport.CopyMblConsignee"
                                                )
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "SeaExport.CopyMblConsignee"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _c(
                                            "el-dropdown-item",
                                            {
                                              attrs: {
                                                command: _vm.$t(
                                                  "SeaExport.CopyNominatedAgentInfo"
                                                )
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "SeaExport.CopyNominatedAgentInfo"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._l(7, function(count) {
                            return _c(
                              "el-form-item",
                              {
                                key: "agentPartyLine" + count,
                                class:
                                  "auto-width " +
                                  _vm.getClass("agentPartyLine", count)
                              },
                              [
                                _c("cargo-input", {
                                  ref: "agentPartyLine" + count,
                                  refInFor: true,
                                  attrs: {
                                    disabled:
                                      _vm.readonly ||
                                      !_vm.elementDict.agentParty.writable,
                                    no: "agentPartyLine" + count,
                                    "auto-uppercase": _vm.isUppercase,
                                    "use-read-only": true
                                  },
                                  on: {
                                    change: function() {
                                      return _vm.wrapAddr(
                                        _vm.form,
                                        "agentPartyLine" + count,
                                        count + 1 > 6
                                          ? null
                                          : "agentPartyLine" + (count + 1),
                                        _vm.maxChars
                                      )
                                    }
                                  },
                                  nativeOn: {
                                    dblclick: function($event) {
                                      return _vm.showAgentPartyDialog($event)
                                    }
                                  },
                                  model: {
                                    value: _vm.form["agentPartyLine" + count],
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "agentPartyLine" + count,
                                        $$v
                                      )
                                    },
                                    expression: "form['agentPartyLine'+count]"
                                  }
                                })
                              ],
                              1
                            )
                          })
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.elementDict.alsoNotify.viewable
                    ? _c(
                        "template",
                        { slot: "alsoNotify" },
                        [
                          _c(
                            "el-form-item",
                            { staticClass: "auto-width" },
                            [
                              _c("line-label", {
                                class: _vm.elementDict.alsoNotify.isRequire
                                  ? "blue"
                                  : "",
                                style: _vm.elementDict.alsoNotify.isRequire
                                  ? ""
                                  : "color:#404144!important",
                                attrs: {
                                  slot: "label",
                                  label: _vm.elementDict.alsoNotify.label
                                },
                                slot: "label"
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { staticClass: "auto-width" },
                            [
                              _c("cargo-rich-textarea", {
                                staticStyle: { height: "110px" },
                                attrs: {
                                  no: "alsoNotify",
                                  disabled:
                                    _vm.readonly ||
                                    !_vm.elementDict.alsoNotify.writable,
                                  "text-chars": 0,
                                  "wrap-symbol": "r",
                                  "auto-half-word": "",
                                  "auto-uppercase": ""
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    return _vm.showAdvanceTextDialog(
                                      "ALSO NOTIFY",
                                      _vm.form.alsoNotify,
                                      function(val) {
                                        _vm.form.alsoNotify = val
                                      },
                                      true,
                                      {
                                        warningCount: 45,
                                        autoUppercase: true,
                                        autoHalfWord: true
                                      }
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.form.alsoNotify,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "alsoNotify", $$v)
                                  },
                                  expression: "form.alsoNotify"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.quantity.viewable
                    ? _c(
                        "el-form-item",
                        {
                          class: _vm.variableCss.quantity,
                          attrs: { slot: "quantity" },
                          slot: "quantity"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.quantity.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.quantity.label
                            },
                            slot: "label"
                          }),
                          _c("auto-number-input", {
                            attrs: {
                              no: "quantity",
                              precision: 0,
                              min: 0,
                              disabled:
                                !_vm.isJydEditJobFields ||
                                _vm.readonly ||
                                !_vm.elementDict.quantity.writable
                            },
                            on: {
                              change: function($event) {
                                return _vm.pm.quantity_Change()
                              },
                              blur: _vm.hblNbr2Change
                            },
                            model: {
                              value: _vm.form.quantity,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "quantity", $$v)
                              },
                              expression: "form.quantity"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.packing.viewable
                    ? _c(
                        "el-form-item",
                        {
                          class: _vm.variableCss.packing,
                          attrs: { slot: "packing" },
                          slot: "packing"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.packing.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.packing.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-packing-select", {
                            attrs: {
                              no: "packing",
                              "default-value": _vm.form.packing,
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.packing.writable
                            },
                            on: {
                              change: function(p) {
                                _vm.pm.packing_Change(p)
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.insideQuantity.viewable
                    ? _c(
                        "el-form-item",
                        {
                          class: _vm.variableCss.insideQuantity,
                          attrs: { slot: "insideQuantity" },
                          slot: "insideQuantity"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.insideQuantity.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.insideQuantity.label
                            },
                            slot: "label"
                          }),
                          _c("auto-number-input", {
                            attrs: {
                              no: "insideQuantity",
                              precision: 0,
                              min: 0,
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.insideQuantity.writable
                            },
                            on: { change: _vm.hblNbr2Change },
                            model: {
                              value: _vm.form.insideQuantity,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "insideQuantity", $$v)
                              },
                              expression: "form.insideQuantity"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.insidePacking.viewable
                    ? _c(
                        "el-form-item",
                        {
                          class: _vm.variableCss.insidePacking,
                          attrs: { slot: "insidePacking" },
                          slot: "insidePacking"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.insidePacking.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.insidePacking.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-packing-select", {
                            attrs: {
                              no: "insidePacking",
                              "default-value": _vm.form.insidePacking,
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.insidePacking.writable
                            },
                            on: {
                              change: function(p) {
                                _vm.form.insidePacking = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.weight.viewable
                    ? _c(
                        "el-form-item",
                        {
                          class: _vm.variableCss.weight,
                          attrs: { slot: "weight" },
                          slot: "weight"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.weight.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.weight.label
                            },
                            slot: "label"
                          }),
                          _c(
                            "div",
                            {
                              staticClass: "form-item-input",
                              class: _vm.readonly ? "input-disabled" : ""
                            },
                            [
                              _c("el-input-number", {
                                staticStyle: { flex: "1" },
                                attrs: {
                                  no: "weight",
                                  precision: 3,
                                  min: 0,
                                  controls: false,
                                  disabled:
                                    !_vm.isJydEditJobFields ||
                                    _vm.readonly ||
                                    !_vm.elementDict.weight.writable
                                },
                                on: {
                                  change: function(p) {
                                    _vm.hblNbr2Change(p)
                                    _vm.refreshWeightCharge(p)
                                    _vm.calculateChargeWeight()
                                  }
                                },
                                model: {
                                  value: _vm.form.weight,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "weight", $$v)
                                  },
                                  expression: "form.weight"
                                }
                              }),
                              _c("span", [_vm._v("KGS")])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.cubage.viewable
                    ? _c(
                        "el-form-item",
                        {
                          class: _vm.variableCss.cubage,
                          attrs: { slot: "cubage" },
                          slot: "cubage"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.cubage.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.cubage.label
                            },
                            slot: "label"
                          }),
                          _c(
                            "div",
                            {
                              staticClass: "form-item-input",
                              class: _vm.readonly ? "input-disabled" : ""
                            },
                            [
                              _c("el-input-number", {
                                staticStyle: { flex: "1" },
                                attrs: {
                                  no: "cubage",
                                  precision: 3,
                                  min: 0,
                                  controls: false,
                                  disabled:
                                    !_vm.isJydEditJobFields ||
                                    _vm.readonly ||
                                    !_vm.elementDict.cubage.writable
                                },
                                on: {
                                  change: function(p) {
                                    _vm.hblNbr2Change()
                                    _vm.calculateChargeWeight()
                                  }
                                },
                                model: {
                                  value: _vm.form.cubage,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "cubage", $$v)
                                  },
                                  expression: "form.cubage"
                                }
                              }),
                              _c("span", [_vm._v("CBM")])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.chargeWeight.viewable
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "chargeWeight" },
                          slot: "chargeWeight"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.chargeWeight.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.chargeWeight.label
                            },
                            slot: "label"
                          }),
                          _c(
                            "div",
                            {
                              staticClass: "form-item-input",
                              class: _vm.readonly ? "input-disabled" : ""
                            },
                            [
                              _c("el-input-number", {
                                staticStyle: { flex: "1" },
                                attrs: {
                                  no: "chargeWeight",
                                  precision: 3,
                                  min: 0,
                                  controls: false,
                                  disabled:
                                    _vm.readonly ||
                                    !_vm.elementDict.chargeWeight.writable
                                },
                                on: { change: _vm.hblNbr2Change },
                                model: {
                                  value: _vm.form.chargeWeight,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "chargeWeight", $$v)
                                  },
                                  expression: "form.chargeWeight"
                                }
                              }),
                              _c("span", [_vm._v("M/T")])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "template",
                    { slot: "cargoEnglishName" },
                    [
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.elementDict.cargoEnglishName.viewable,
                              expression:
                                "elementDict.cargoEnglishName.viewable"
                            }
                          ],
                          class:
                            "auto-width " + _vm.variableCss.cargoEnglishName
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "flex-end"
                              }
                            },
                            [
                              _vm.job.typeHBL ===
                              _vm.BillType.MERGE_BILL_TYPE.code
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        no: "getCargoEnglishNameFromMergeJob",
                                        disabled:
                                          _vm.readonly ||
                                          !_vm.elementDict.cargoEnglishName
                                            .writable,
                                        type: "primary"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.pm.getCargoEnglishNameFromMergeJob()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "SeaExport.CopyEnglishDescriptionOfGoodsFromMergeJob"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.elementDict.cargoEnglishName.viewable,
                              expression:
                                "elementDict.cargoEnglishName.viewable"
                            }
                          ],
                          class:
                            "auto-width " + _vm.variableCss.cargoEnglishName
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.cargoEnglishName.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.cargoEnglishName.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-rich-textarea", {
                            ref: "cargoTextarea1",
                            staticStyle: { height: "110px" },
                            attrs: {
                              "show-count": true,
                              no: "cargoTextarea1",
                              disabled:
                                !_vm.isEdit ||
                                !_vm.elementDict.cargoEnglishName.writable,
                              "text-chars": 0,
                              "warning-count": -1,
                              "wrap-symbol": "r",
                              "auto-uppercase": _vm.isUppercaseByConfig,
                              "auto-half-word": ""
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.EnglishDescriptionOfGoods"),
                                  _vm.form.cargoEnglishName,
                                  function(val) {
                                    _vm.form.cargoEnglishName = val
                                  },
                                  _vm.isUppercaseByConfig,
                                  {
                                    autoHalfWord: true,
                                    autoUppercase: _vm.isUppercaseByConfig
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.form.cargoEnglishName,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "cargoEnglishName", $$v)
                              },
                              expression: "form.cargoEnglishName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "template",
                    { slot: "mark" },
                    [
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.elementDict.mark.viewable,
                              expression: "elementDict.mark.viewable"
                            }
                          ],
                          class: "auto-width " + _vm.variableCss.mark,
                          attrs: { "label-width": "0" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "flex-end"
                              }
                            },
                            [
                              _vm.job.typeHBL ===
                              _vm.BillType.MERGE_BILL_TYPE.code
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        no: "getMarkFromMergeJob",
                                        type: "primary",
                                        disabled:
                                          _vm.readonly ||
                                          !_vm.elementDict.mark.writable
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.pm.getMarkFromMergeJob()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "SeaExport.CopyMarkFromMergeJob"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.elementDict.mark.viewable,
                              expression: "elementDict.mark.viewable"
                            }
                          ],
                          class: "auto-width " + _vm.variableCss.mark
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.mark.isRequire ? "blue" : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.mark.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-rich-textarea", {
                            ref: "cargoTextarea2",
                            staticStyle: { height: "110px" },
                            attrs: {
                              "show-count": true,
                              no: "cargoTextarea2",
                              "text-chars": 0,
                              "warning-count": -1,
                              "wrap-symbol": "r",
                              "auto-uppercase": _vm.isUppercaseByConfig,
                              "auto-half-word": "",
                              disabled:
                                !_vm.isEdit || !_vm.elementDict.mark.writable
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.Marks"),
                                  _vm.form.mark,
                                  function(val) {
                                    _vm.form.mark = val
                                  },
                                  _vm.isUppercaseByConfig,
                                  {
                                    autoHalfWord: true,
                                    autoUppercase: _vm.isUppercaseByConfig
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.form.mark,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "mark", $$v)
                              },
                              expression: "form.mark"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.elementDict.quantitySum.viewable
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "auto-width",
                          attrs: { slot: "quantitySum" },
                          slot: "quantitySum"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.quantitySum.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.quantitySum.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            attrs: { disabled: true, no: "quantitySum" },
                            model: {
                              value: _vm.form.quantitySum,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "quantitySum", $$v)
                              },
                              expression: "form.quantitySum"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.hblNbr2.viewable
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "hblNbr2" }, slot: "hblNbr2" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.hblNbr2.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.hblNbr2.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            attrs: {
                              no: "hblNbr2",
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.hblNbr2.writable
                            },
                            on: { input: _vm.hblNbr2Change },
                            model: {
                              value: _vm.form.hblNbr2,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "hblNbr2", $$v)
                              },
                              expression: "form.hblNbr2"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.warehouseNo.viewable
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "warehouseNo" }, slot: "warehouseNo" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.warehouseNo.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.warehouseNo.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            attrs: {
                              no: "warehouseNo",
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.warehouseNo.writable
                            },
                            on: { change: _vm.hblNbr2Change },
                            model: {
                              value: _vm.form.warehouseNo,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "warehouseNo", $$v)
                              },
                              expression: "form.warehouseNo"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.mblId.viewable
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "mblId" }, slot: "mblId" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.mblId.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.mblId.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-combo-box", {
                            attrs: {
                              no: "mblId",
                              disabled:
                                _vm.readonly ||
                                _vm.splitOrder.rowData.length > 0 ||
                                !_vm.elementDict.mblId.writable,
                              options: _vm.pm.joinMBLs,
                              "label-field": "mblNbr2",
                              "value-field": "uuid",
                              "need-old-value": true,
                              "forbid-values": [""]
                            },
                            model: {
                              value: _vm.form.mblId,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "mblId", $$v)
                              },
                              expression: "form.mblId"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.serialNo.viewable
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "serialNo" }, slot: "serialNo" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.serialNo.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.serialNo.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            attrs: {
                              no: "serialNo",
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.serialNo.writable
                            },
                            model: {
                              value: _vm.form.serialNo,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "serialNo", $$v)
                              },
                              expression: "form.serialNo"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.vessel.viewable
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "vessel" }, slot: "vessel" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.vessel.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.vessel.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-advance-select", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "vessel",
                              disabled:
                                _vm.readonly ||
                                !_vm.pm._lclslaveEnabled ||
                                !_vm.elementDict.vessel.writable,
                              "select-type":
                                _vm.selectTypeNames.basic_data_Vessel,
                              filterable: "",
                              clearable: "",
                              "allow-create": _vm.pm._allowEditingVessel,
                              "default-value": _vm.job.vessel
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.onVesselSelectionChange(p)
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.voyageFlight.viewable
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "voyageFlight" },
                          slot: "voyageFlight"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.voyageFlight.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.voyageFlight.label
                            },
                            slot: "label"
                          }),
                          _c(
                            "el-select",
                            {
                              ref: "voyageFlight",
                              attrs: {
                                no: "voyageFlight",
                                disabled:
                                  _vm.readonly ||
                                  !_vm.pm._lclslaveEnabled ||
                                  _vm.pm.editVoyageMode !== 1 ||
                                  !_vm.elementDict.voyageFlight.writable,
                                filterable: "",
                                "allow-create": ""
                              },
                              on: {
                                focus: function($event) {
                                  return _vm.pm.txtVoyagefocusInHandler()
                                },
                                blur: function($event) {
                                  return _vm.pm.txtVoyagefocusOutHandler()
                                }
                              },
                              model: {
                                value: _vm.job.voyageFlight,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "voyageFlight", $$v)
                                },
                                expression: "job.voyageFlight"
                              }
                            },
                            _vm._l(_vm.pm._voyages, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.voyageNo,
                                  value: item.voyageNo
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.sailingDate.viewable
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "sailingDate" }, slot: "sailingDate" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.sailingDate.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.sailingDate.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            attrs: {
                              value: _vm.sailingDate,
                              disabled: true,
                              no: "sailingDate"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.dispatchingPlaceCode.viewable
                    ? _c(
                        "el-form-item",
                        {
                          class: _vm.variableCss.dispatchingPlace,
                          attrs: { slot: "dispatchingPlaceCode" },
                          slot: "dispatchingPlaceCode"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.dispatchingPlaceCode
                              .isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.dispatchingPlaceCode.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-advance-select", {
                            attrs: {
                              disabled: true,
                              "select-type":
                                _vm.selectTypeNames.basic_data_Seaport,
                              filterable: "",
                              "default-value":
                                _vm.form.dispatchingPlaceCode || "",
                              "tag-name": "englishName",
                              no: "1"
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.portChange(p, "dispatchingPlace")
                              }
                            }
                          }),
                          _c("el-input", {
                            attrs: {
                              no: "dispatchingPlace",
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.dispatchingPlaceCode.writable
                            },
                            model: {
                              value: _vm.form.dispatchingPlace,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "dispatchingPlace", $$v)
                              },
                              expression: "form.dispatchingPlace"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.loadingPortCode.viewable
                    ? _c(
                        "el-form-item",
                        {
                          class: _vm.variableCss.loadingPort,
                          attrs: { slot: "loadingPortCode" },
                          slot: "loadingPortCode"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.loadingPortCode.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.loadingPortCode.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-advance-select", {
                            attrs: {
                              disabled: true,
                              "select-type":
                                _vm.selectTypeNames.basic_data_Seaport,
                              filterable: "",
                              "default-value": _vm.form.loadingPortCode || "",
                              "tag-name": "englishName",
                              no: "2"
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.portChange(p, "loadingPort")
                              }
                            }
                          }),
                          _c("el-input", {
                            attrs: {
                              no: "loadingPort",
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.loadingPortCode.writable
                            },
                            model: {
                              value: _vm.form.loadingPort,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "loadingPort", $$v)
                              },
                              expression: "form.loadingPort"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.dischargingPortCode.viewable
                    ? _c(
                        "el-form-item",
                        {
                          class: _vm.variableCss.dischargingPort,
                          attrs: { slot: "dischargingPortCode" },
                          slot: "dischargingPortCode"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.dischargingPortCode.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.dischargingPortCode.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-advance-select", {
                            attrs: {
                              disabled: true,
                              "select-type":
                                _vm.selectTypeNames.basic_data_Seaport,
                              filterable: "",
                              "default-value":
                                _vm.form.dischargingPortCode || "",
                              "tag-name": "englishName",
                              no: "3"
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.portChange(p, "dischargingPort")
                              }
                            }
                          }),
                          _c("el-input", {
                            attrs: {
                              no: "dischargingPort",
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.dischargingPortCode.writable
                            },
                            model: {
                              value: _vm.form.dischargingPort,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "dischargingPort", $$v)
                              },
                              expression: "form.dischargingPort"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.destinationPortCode.viewable
                    ? _c(
                        "el-form-item",
                        {
                          class: _vm.variableCss.destinationPort,
                          attrs: { slot: "destinationPortCode" },
                          slot: "destinationPortCode"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.destinationPortCode.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.destinationPortCode.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-advance-select", {
                            attrs: {
                              disabled: true,
                              "select-type":
                                _vm.selectTypeNames.basic_data_Seaport,
                              filterable: "",
                              "default-value":
                                _vm.form.destinationPortCode || "",
                              "tag-name": "englishName",
                              no: "4"
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.portChange(p, "destinationPort")
                              }
                            }
                          }),
                          _c("el-input", {
                            attrs: {
                              no: "destinationPort",
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.destinationPortCode.writable
                            },
                            model: {
                              value: _vm.form.destinationPort,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "destinationPort", $$v)
                              },
                              expression: "form.destinationPort"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.destinationPlace.viewable
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "destinationPlace" },
                          slot: "destinationPlace"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.destinationPlace.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.destinationPlace.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            attrs: {
                              no: "destinationPlace",
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.destinationPlace.writable
                            },
                            model: {
                              value: _vm.form.destinationPlace,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "destinationPlace", $$v)
                              },
                              expression: "form.destinationPlace"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.paymentTerm.viewable
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "paymentTerm" }, slot: "paymentTerm" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.paymentTerm.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.paymentTerm.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-advance-select", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "paymentTerm",
                              "select-type":
                                _vm.selectTypeNames.basic_data_PaymentTerm,
                              filterable: "",
                              "default-value": _vm.form.paymentTerm,
                              "allow-create": true,
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.paymentTerm.writable
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.paymentSelectHblChange(p)
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.paymentPlaceBL.viewable
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "paymentPlaceBL" },
                          slot: "paymentPlaceBL"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.paymentPlaceBL.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.paymentPlaceBL.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            attrs: {
                              no: "paymentPlaceBL",
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.paymentPlaceBL.writable
                            },
                            model: {
                              value: _vm.form.paymentPlaceBL,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "paymentPlaceBL", $$v)
                              },
                              expression: "form.paymentPlaceBL"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.freightTermHBL.viewable
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "freightTermHBL" },
                          slot: "freightTermHBL"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.freightTermHBL.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.freightTermHBL.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            attrs: {
                              no: "freightTermHBL",
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.freightTermHBL.writable
                            },
                            model: {
                              value: _vm.form.freightTermHBL,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "freightTermHBL", $$v)
                              },
                              expression: "form.freightTermHBL"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.blNumber.viewable
                    ? _c(
                        "el-form-item",
                        {
                          class: _vm.variableCss.BLNumber,
                          attrs: { slot: "blNumber" },
                          slot: "blNumber"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.blNumber.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.blNumber.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            attrs: {
                              no: "blNumber",
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.blNumber.writable
                            },
                            model: {
                              value: _vm.form.blNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "blNumber", $$v)
                              },
                              expression: "form.blNumber"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.signPlaceBL.viewable
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "signPlaceBL" }, slot: "signPlaceBL" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.signPlaceBL.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.signPlaceBL.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            attrs: {
                              no: "signPlaceBL",
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.signPlaceBL.writable
                            },
                            model: {
                              value: _vm.form.signPlaceBL,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "signPlaceBL", $$v)
                              },
                              expression: "form.signPlaceBL"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.signDateBL.viewable
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "signDateBL" }, slot: "signDateBL" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.signDateBL.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.signDateBL.label
                            },
                            slot: "label"
                          }),
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "signDateBL",
                              type: "date",
                              "value-format": "yyyy-MM-dd",
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.signDateBL.writable
                            },
                            model: {
                              value: _vm.form.signDateBL,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "signDateBL", $$v)
                              },
                              expression: "form.signDateBL"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.remarks.viewable
                    ? _c(
                        "el-form-item",
                        {
                          class: _vm.variableCss.remarks,
                          attrs: { slot: "remarks" },
                          slot: "remarks"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.remarks.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.remarks.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            attrs: {
                              no: "remarks",
                              type: "textarea",
                              rows: 5,
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.remarks.writable
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.BlRemarks"),
                                  _vm.form.remarks,
                                  function(val) {
                                    _vm.form.remarks = val
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.form.remarks,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "remarks", $$v)
                              },
                              expression: "form.remarks"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.hsCode.viewable
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "hsCode" }, slot: "hsCode" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.hsCode.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.hsCode.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            attrs: {
                              no: "hsCode",
                              type: "textarea",
                              rows: 5,
                              disabled:
                                _vm.readonly || !_vm.elementDict.hsCode.writable
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.HsCode"),
                                  _vm.form.hsCode,
                                  function(val) {
                                    _vm.form.hsCode = val
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.form.hsCode,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "hsCode", $$v)
                              },
                              expression: "form.hsCode"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.customerCfmException.viewable
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "customerCfmException" },
                          slot: "customerCfmException"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.customerCfmException
                              .isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.customerCfmException.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            attrs: {
                              no: "customerCfmException",
                              type: "textarea",
                              rows: 5,
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.customerCfmException.writable
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showAdvanceTextDialog(
                                  _vm.elementDict.customerCfmException.label,
                                  _vm.form.customerCfmException,
                                  function(val) {
                                    _vm.form.customerCfmException = val
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.form.customerCfmException,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "customerCfmException", $$v)
                              },
                              expression: "form.customerCfmException"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.orderBusinessAssociation.viewable &&
                  _vm.job.typeHBL === _vm.BillType.SPLIT_BILL_TYPE.code
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "auto-width",
                          attrs: {
                            slot: "orderBusinessAssociation",
                            "label-width": "0"
                          },
                          slot: "orderBusinessAssociation"
                        },
                        [
                          _c("cargo-ag-grid", {
                            key: "OtherInfo",
                            staticStyle: { width: "100%", height: "200px" },
                            attrs: {
                              no: "OtherInfo",
                              "grid-options": _vm.splitOrder.gridOptions,
                              "column-defs": _vm.splitOrder.columnDefs,
                              "row-data": _vm.splitOrderFinalRowData,
                              "auto-fit-content": false
                            },
                            on: { gridReady: _vm.splitOrderGridReady }
                          }),
                          _c("div", { staticStyle: { padding: "5px 0" } }, [
                            _c(
                              "div",
                              { staticStyle: { float: "right" } },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      no: "onAddCargoDoc2",
                                      type: "primary",
                                      disabled:
                                        _vm.readonly ||
                                        !_vm.elementDict
                                          .orderBusinessAssociation.writable
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.pm.onAddCargoDoc2(true)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.Add")))]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      no: "onRemoveCargoDoc",
                                      type: "danger",
                                      disabled:
                                        _vm.readonly ||
                                        !_vm.elementDict
                                          .orderBusinessAssociation.writable
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.pm.onRemoveCargoDoc()
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")))]
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.orderBusinessAssociation.viewable &&
                  _vm.job.typeHBL === _vm.BillType.MERGE_BILL_TYPE.code
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "auto-width",
                          attrs: {
                            slot: "orderBusinessAssociation",
                            "label-width": "0"
                          },
                          slot: "orderBusinessAssociation"
                        },
                        [
                          _c("cargo-ag-grid", {
                            key: "150004",
                            staticStyle: { width: "100%", height: "200px" },
                            attrs: {
                              no: "150004",
                              "config-module": "150004",
                              "grid-options": _vm.mergeOrder.gridOptions,
                              "column-defs": _vm.mergeOrder.columnDefs,
                              "row-data": _vm.mergeOrderFinalRowData,
                              "auto-fit-content": false
                            },
                            on: {
                              gridReady: function(params) {
                                _vm.mergeOrder.gridApi = params.api
                              }
                            }
                          }),
                          _c("div", { staticStyle: { padding: "5px 0" } }, [
                            _c(
                              "div",
                              { staticStyle: { float: "right" } },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      no: "onMergeAddJob2",
                                      type: "primary",
                                      disabled:
                                        _vm.readonly ||
                                        !_vm.elementDict
                                          .orderBusinessAssociation.writable
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.pm.onMergeAddJob()
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.Add3")))]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      no: "onMergeRemoveJob2",
                                      type: "danger",
                                      disabled:
                                        _vm.readonly ||
                                        !_vm.elementDict
                                          .orderBusinessAssociation.writable
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.pm.onMergeRemoveJob()
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")))]
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.releaseType.viewable
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "releaseType" }, slot: "releaseType" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.releaseType.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.releaseType.label
                            },
                            slot: "label"
                          }),
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                no: "releaseType",
                                disabled:
                                  _vm.readonly ||
                                  !_vm.elementDict.releaseType.writable,
                                value: _vm.form.releaseType || ""
                              },
                              on: {
                                input: function(val) {
                                  _vm.form.releaseType = val
                                },
                                change: function(val) {
                                  _vm.pm.cmbreleaseTypeMBLChangeHandler(val)
                                }
                              }
                            },
                            _vm._l(_vm.blModeList, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.name,
                                  value: item.serialNumber
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.lblCfrState.viewable
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "red ",
                          attrs: { slot: "lblCfrState" },
                          slot: "lblCfrState"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.lblCfrState.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.lblCfrState.label
                            },
                            slot: "label"
                          }),
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-input", {
                                staticStyle: { flex: "1" },
                                attrs: {
                                  value: _vm.lblCfrState,
                                  disabled: true
                                }
                              }),
                              _vm.showXhqOverseasAgentFeedbackLink
                                ? _c(
                                    "el-link",
                                    {
                                      staticStyle: {
                                        color: "blue",
                                        "margin-left": "5px"
                                      },
                                      attrs: {
                                        no: "xhqOverseasAgentFeedbackLink"
                                      },
                                      on: {
                                        click:
                                          _vm.xhqShowOverseasAgentFeedbackDialog
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("SeaExport.View")) + " "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.billLadingIssued.viewable
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "red",
                          attrs: { slot: "billLadingIssued" },
                          slot: "billLadingIssued"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.billLadingIssued.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.billLadingIssued.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            attrs: { disabled: true, no: "6" },
                            model: {
                              value: _vm.billLadingIssued,
                              callback: function($$v) {
                                _vm.billLadingIssued = $$v
                              },
                              expression: "billLadingIssued"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.lblReleaseState.viewable
                    ? _c(
                        "template",
                        { slot: "lblReleaseState" },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { "label-width": "0" } },
                            [
                              _vm.OpenXHQDocumentCenter
                                ? _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "permission",
                                          rawName: "v-permission",
                                          value: ["button_HBL_surrendered"],
                                          expression:
                                            "['button_HBL_surrendered']"
                                        }
                                      ],
                                      attrs: {
                                        disabled:
                                          _vm.isEdit ||
                                          !_vm.elementDict.releaseType.writable,
                                        no: "surrendered",
                                        type: "primary"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.pm.toSurrendered()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("SeaExport.Surrendered"))
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "red ",
                              attrs: {
                                label: _vm.$t("SeaExport.ReleasingStatus")
                              }
                            },
                            [
                              _c("line-label", {
                                class: _vm.elementDict.lblReleaseState.isRequire
                                  ? "blue"
                                  : "",
                                attrs: {
                                  slot: "label",
                                  label: _vm.elementDict.lblReleaseState.label
                                },
                                slot: "label"
                              }),
                              _c("el-input", {
                                attrs: {
                                  value: _vm.lblReleaseState,
                                  disabled: true,
                                  no: "7"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-right": "6px" },
                                  attrs: {
                                    no: "DataSent",
                                    value: _vm.form.releaseReview === 1,
                                    disabled: true
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.DataSent")))]
                              ),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-right": "6px" },
                                  attrs: {
                                    no: "payable",
                                    value: _vm.form.payable,
                                    disabled: true
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.Completed")))]
                              ),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-right": "0px" },
                                  attrs: {
                                    no: "withhold",
                                    value: _vm.form.withhold,
                                    disabled: true
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.CargoDetention"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.requestReleaseState.viewable
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "red",
                          attrs: { slot: "requestReleaseState" },
                          slot: "requestReleaseState"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.requestReleaseState.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.requestReleaseState.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            attrs: {
                              value:
                                _vm.form.requestReleaseState === 0
                                  ? _vm.$t("SeaExport.NotApplying")
                                  : _vm.$t("SeaExport.Requested"),
                              disabled: true
                            }
                          }),
                          _c(
                            "cargo-button-container",
                            {
                              staticStyle: {
                                float: "right",
                                "margin-left": "5px"
                              },
                              attrs: {
                                no: "requestReleaseState",
                                disabled:
                                  _vm.btnBLConfirmDisabled ||
                                  !_vm.cooperateEdit ||
                                  !_vm.elementDict.requestReleaseState.writable
                              },
                              on: {
                                click: function($event) {
                                  return _vm.pm.btnRequestReleasingClickHandler()
                                }
                              }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "permission",
                                      rawName: "v-permission",
                                      value: ["button_M/HBL_SingleReleaseHBL"],
                                      expression:
                                        "['button_M/HBL_SingleReleaseHBL']"
                                    }
                                  ],
                                  attrs: { type: "primary" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.form.requestReleaseState === 0
                                        ? _vm.$t("SeaExport.ApplyForARelease")
                                        : _vm.$t(
                                            "SeaExport.WithdrawTheRequestForRelease"
                                          )
                                    ) + " "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.agreePayDate.viewable
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "agreePayDate" },
                          slot: "agreePayDate"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.agreePayDate.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.agreePayDate.label
                            },
                            slot: "label"
                          }),
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              disabled:
                                _vm.isDatePickerDisabled ||
                                _vm.readonly ||
                                !_vm.elementDict.agreePayDate.writable,
                              type: "date",
                              "value-format": "yyyy-MM-dd",
                              no: "8"
                            },
                            on: { input: _vm.handleDateChange },
                            model: {
                              value: _vm.form.agreePayDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "agreePayDate", $$v)
                              },
                              expression: "form.agreePayDate"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.withholdDate.viewable
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "withholdDate" },
                          slot: "withholdDate"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.withholdDate.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.withholdDate.label
                            },
                            slot: "label"
                          }),
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              disabled:
                                true || !_vm.elementDict.withholdDate.writable,
                              type: "date",
                              "value-format": "yyyy-MM-dd",
                              no: "9"
                            },
                            model: {
                              value: _vm.form.withholdDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "withholdDate", $$v)
                              },
                              expression: "form.withholdDate"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.printParam4.viewable
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "printParam4" }, slot: "printParam4" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.printParam4.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.printParam4.label
                            },
                            slot: "label"
                          }),
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                no: "printParam4",
                                disabled:
                                  _vm.readonly ||
                                  !_vm.elementDict.printParam4.writable,
                                placeholder: _vm.readonly
                                  ? ""
                                  : _vm.$t("CargoMsg.Cargo_PleaseSelect"),
                                filterable: "",
                                "allow-create": ""
                              },
                              model: {
                                value: _vm.form.printParam4,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "printParam4", $$v)
                                },
                                expression: "form.printParam4"
                              }
                            },
                            _vm._l(_vm.pm.printParam4Type, function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.label, value: item.data }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.printParam5.viewable
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "printParam5" }, slot: "printParam5" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.printParam5.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.printParam5.label
                            },
                            slot: "label"
                          }),
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                no: "printParam5",
                                disabled:
                                  _vm.readonly ||
                                  !_vm.elementDict.printParam5.writable,
                                placeholder: _vm.readonly
                                  ? ""
                                  : _vm.$t("CargoMsg.Cargo_PleaseSelect")
                              },
                              model: {
                                value: _vm.form.printParam5,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "printParam5", $$v)
                                },
                                expression: "form.printParam5"
                              }
                            },
                            _vm._l(_vm.pm.printParam5Type, function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.label, value: item.data }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.seaeq.viewable
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "seaeq" }, slot: "seaeq" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.seaeq.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.seaeq.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            attrs: {
                              disabled:
                                _vm.readonly || !_vm.elementDict.seaeq.writable,
                              no: "seaeq",
                              type: "textarea",
                              rows: 5
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.ContainerAmount"),
                                  _vm.form.seaeq,
                                  function(val) {
                                    _vm.form.seaeq = val
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.form.seaeq,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "seaeq", $$v)
                              },
                              expression: "form.seaeq"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.container.viewable
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "container" }, slot: "container" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.container.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.container.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            attrs: {
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.container.writable,
                              no: "container",
                              type: "textarea",
                              rows: 5
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.CNTRNOSSEALNOS"),
                                  _vm.form.container,
                                  function(val) {
                                    _vm.form.container = val
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.form.container,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "container", $$v)
                              },
                              expression: "form.container"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.txtCarrierScAc.viewable
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "txtCarrierScAc" },
                          slot: "txtCarrierScAc"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.txtCarrierScAc.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.txtCarrierScAc.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            attrs: {
                              value: _vm.job.carrierScac || _vm.txtCarrierScAc,
                              disabled: true,
                              no: "10"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.withholdReason &&
                  _vm.elementDict.withholdReason.viewable
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "withholdReason" },
                          slot: "withholdReason"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.withholdReason.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.withholdReason.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            attrs: {
                              value: _vm.form.withholdReason,
                              disabled: true,
                              no: "25"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.txtBookingAgentScAc.viewable
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "txtBookingAgentScAc" },
                          slot: "txtBookingAgentScAc"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.txtBookingAgentScAc.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.txtBookingAgentScAc.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            attrs: {
                              value: _vm.txtBookingAgentScAc,
                              disabled: true,
                              no: "11"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.shipperTel.viewable
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "shipperTel" }, slot: "shipperTel" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.shipperTel.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.shipperTel.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            attrs: {
                              no: "shipperTel",
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.shipperTel.writable
                            },
                            model: {
                              value: _vm.form.shipperTel,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "shipperTel", $$v)
                              },
                              expression: "form.shipperTel"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.consigneeTel.viewable
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "consigneeTel" },
                          slot: "consigneeTel"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.consigneeTel.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.consigneeTel.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            attrs: {
                              no: "consigneeTel",
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.consigneeTel.writable
                            },
                            model: {
                              value: _vm.form.consigneeTel,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "consigneeTel", $$v)
                              },
                              expression: "form.consigneeTel"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.notifyTel.viewable
                    ? _c(
                        "el-form-item",
                        { attrs: { slot: "notifyTel" }, slot: "notifyTel" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.notifyTel.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.notifyTel.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            attrs: {
                              no: "notifyTel",
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.notifyTel.writable
                            },
                            model: {
                              value: _vm.form.notifyTel,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "notifyTel", $$v)
                              },
                              expression: "form.notifyTel"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.elementDict.portRequirement.viewable
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { slot: "portRequirement" },
                          slot: "portRequirement"
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.portRequirement.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.portRequirement.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            attrs: {
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.portRequirement.writable,
                              no: "portRequirement",
                              type: "textarea",
                              rows: 5
                            },
                            model: {
                              value: _vm.form.portRequirement,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "portRequirement", $$v)
                              },
                              expression: "form.portRequirement"
                            }
                          }),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "line-height": "16px",
                                "margin-top": "5px",
                                cursor: "pointer"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.downloadAttachment(
                                    _vm.form.regionWarehouseMappingUuid
                                  )
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-paperclip",
                                staticStyle: { "font-size": "16px" }
                              }),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    "text-decoration": "underline",
                                    color: "blue"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "SystemMaintenance.PortRequirementsRelatedDocuments"
                                      )
                                    )
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.elementDict.billOfLadingPackingInfo.viewable,
                          expression:
                            "elementDict.billOfLadingPackingInfo.viewable"
                        }
                      ],
                      key: "billOfLadingPackingInfo",
                      staticClass: "section",
                      attrs: { slot: "billOfLadingPackingInfo" },
                      slot: "billOfLadingPackingInfo"
                    },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(
                          _vm._s(_vm.$t("SeaExport.BillOfLadingPackingInfo"))
                        )
                      ]),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isEdit,
                                  expression: "isEdit"
                                }
                              ],
                              staticStyle: { padding: "5px 0" }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    no: "AddPackingInfo",
                                    type: "primary"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.cargoDocUsageSelectedDialog.visible = true
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.AddPackingInfo"))
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    no: "RemovePackingInfo",
                                    type: "primary"
                                  },
                                  on: {
                                    click: _vm.removeContainerUsageClickHandler
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.RemovePackingInfo")
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c("cargo-ag-grid", {
                            staticStyle: { width: "100%", height: "350px" },
                            attrs: {
                              no: "BillOfLadingPackingInfo",
                              "grid-options": _vm.container.gridOptions,
                              "column-defs": _vm.containerColumnDefs,
                              "row-data": _vm.ediContainerFinalRowData
                            },
                            on: {
                              gridReady: function(params) {
                                _vm.container.gridApi = params.api
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.elementDict.freightChargesInfo.viewable,
                          expression: "elementDict.freightChargesInfo.viewable"
                        }
                      ],
                      key: "freightChargesInfo",
                      staticClass: "section",
                      attrs: { slot: "freightChargesInfo" },
                      slot: "freightChargesInfo"
                    },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.freightChargesInfo")))
                      ]),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isEdit,
                                  expression: "isEdit"
                                }
                              ],
                              staticStyle: { padding: "5px 0" }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { no: "Add2", type: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.showEditDialog(true)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.Add")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { no: "Edit2", type: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.showEditDialog(false)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.Edit")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { no: "Delete2", type: "danger" },
                                  on: { click: _vm.remove }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")))]
                              )
                            ],
                            1
                          ),
                          _c("cargo-ag-grid", {
                            staticStyle: { width: "100%", height: "350px" },
                            attrs: {
                              no: "freightChargesInfo",
                              "grid-options": _vm.gridOptions,
                              "column-defs": _vm.columnDefs,
                              "row-data": _vm.finalRowData
                            },
                            on: {
                              gridReady: function(params) {
                                _vm.gridApi = params.api
                              }
                            }
                          }),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                padding: "5px 0",
                                "font-size": "12px"
                              }
                            },
                            [
                              _c(
                                "span",
                                { staticStyle: { color: "#0A0AFF" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.freightChargesUSDTotal")
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "i",
                                {
                                  staticStyle: {
                                    "margin-left": "15px",
                                    "margin-right": "5px"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.form.freightChargeEnUpper))]
                              ),
                              _c("i", [
                                _vm._v(
                                  "(" +
                                    _vm._s(
                                      _vm.NumberUtils.formatNumber(
                                        _vm.form.freightChargeTotal,
                                        2
                                      )
                                    ) +
                                    ")"
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                2
              ),
              _c(
                "el-dialog",
                {
                  directives: [
                    { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
                  ],
                  attrs: {
                    visible: _vm.advanceTextDialog.visible,
                    title: _vm.advanceTextDialog.title,
                    width: "600px",
                    "close-on-click-modal": false,
                    "close-on-press-escape": false
                  },
                  on: {
                    "update:visible": function($event) {
                      return _vm.$set(_vm.advanceTextDialog, "visible", $event)
                    }
                  }
                },
                [
                  _c("cargo-rich-textarea", {
                    ref: "advanceTextDialogTextarea",
                    staticStyle: { height: "320px" },
                    attrs: {
                      "text-chars": _vm.advanceTextDialog.formatObj.maxChar,
                      "auto-uppercase": _vm.advanceTextDialog.isUppercase,
                      "warning-count":
                        _vm.advanceTextDialog.formatObj.warningCount,
                      "auto-half-word":
                        _vm.advanceTextDialog.formatObj.autoHalfWord,
                      disabled: _vm.readonly,
                      no: "12"
                    },
                    model: {
                      value: _vm.advanceTextDialog.value,
                      callback: function($$v) {
                        _vm.$set(_vm.advanceTextDialog, "value", $$v)
                      },
                      expression: "advanceTextDialog.value"
                    }
                  }),
                  _c(
                    "span",
                    { attrs: { slot: "footer" }, slot: "footer" },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isEdit,
                              expression: "isEdit"
                            }
                          ],
                          attrs: { type: "primary", no: "13" },
                          on: { click: _vm.finishAdvanceText }
                        },
                        [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { no: "14" },
                          on: {
                            click: function($event) {
                              _vm.advanceTextDialog.visible = false
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("bill-address-dialog", {
                attrs: {
                  visible: _vm.billAddressDialog.visible,
                  job: _vm.job,
                  params: _vm.form
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(_vm.billAddressDialog, "visible", $event)
                  },
                  callback: _vm.codeSearchCallback
                }
              }),
              _c("job-no-transcribe-dialog", {
                attrs: {
                  visible: _vm.searchJobNoDialog.visible,
                  params: _vm.searchJobNoDialog.params
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(_vm.searchJobNoDialog, "visible", $event)
                  },
                  selected: _vm.searchJobNoDialog.selectHandler
                }
              }),
              _vm.emailInput.visible
                ? _c("email-input", {
                    attrs: {
                      visible: _vm.emailInput.visible,
                      context: _vm.context,
                      job: _vm.job,
                      source: "tabHBL2",
                      "is-copy-link": true,
                      "job-eamil-data": _vm.jobEamilData,
                      "send-email-data": _vm.emailInput,
                      "send-call-back": _vm.onEmailExecute
                    },
                    on: {
                      "update:visible": function($event) {
                        return _vm.$set(_vm.emailInput, "visible", $event)
                      }
                    }
                  })
                : _vm._e(),
              _c("transcribe-dialog", {
                attrs: { visible: _vm.transcribeDialog.visible, job: _vm.job },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(_vm.transcribeDialog, "visible", $event)
                  },
                  callback: _vm.transcribeCallback
                }
              }),
              _c("address-format-dialog", {
                attrs: {
                  visible: _vm.addressFormatDialog.visible,
                  job: _vm.job,
                  params: _vm.addressFormatDialog.params
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(_vm.addressFormatDialog, "visible", $event)
                  }
                }
              }),
              _c("add-cargo-doc-container-dialog", {
                attrs: {
                  visible: _vm.cargoDocUsageSelectedDialog.visible,
                  job: _vm.job,
                  "doc-type": _vm.CargoDocConsts.HBL2,
                  "uuid-not-empty": true,
                  "cargo-docs":
                    _vm.job.typeHBL === _vm.BillType.SPLIT_BILL_TYPE.code
                      ? _vm.splitOrderFinalRowData
                      : null
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(
                      _vm.cargoDocUsageSelectedDialog,
                      "visible",
                      $event
                    )
                  },
                  callback: _vm.cargoDocUsageSelectedDialog.callback
                }
              }),
              _c("cargo-template-selector-dialog", {
                attrs: {
                  visible: _vm.templateSelectorDialog.visible,
                  ctx: _vm.templateSelectorDialog.ctx,
                  category: _vm.templateSelectorDialog.category,
                  data: _vm.templateSelectorDialog.data,
                  context: _vm.context,
                  "pre-print-callback": _vm.prePrintCallback,
                  "printed-callback": _vm.printedCallback,
                  "v2-check-callback": _vm.v2CheckCallback,
                  "return-main-callback": _vm.returnMainCallback
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(
                      _vm.templateSelectorDialog,
                      "visible",
                      $event
                    )
                  }
                }
              }),
              _c(
                "el-dialog",
                {
                  directives: [
                    { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
                  ],
                  attrs: {
                    visible: _vm.editDialog.visible,
                    title: _vm.editDialog.title,
                    width: "465px",
                    "close-on-click-modal": false
                  },
                  on: {
                    "update:visible": function($event) {
                      return _vm.$set(_vm.editDialog, "visible", $event)
                    }
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "app-main-inner-row",
                      staticStyle: { "padding-bottom": "10px" }
                    },
                    [
                      _c(
                        "el-form",
                        {
                          attrs: {
                            "label-width": "100px",
                            "label-position": "left"
                          }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("SeaExport.ChargeItem") }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_ChargeItem,
                                  filterable: "",
                                  "default-value":
                                    _vm.editDialog.form.chargeItemId || "",
                                  no: "15"
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.editDialog.form.chargeItemId = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("SeaExport.ChargeClause") }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_PaymentTerm,
                                  filterable: "",
                                  "default-value":
                                    _vm.editDialog.form.paymentTermHBL,
                                  no: "16"
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.editDialog.form.paymentTermHBL = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("SeaExport.Currency") } },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Currency,
                                  filterable: "",
                                  "default-value": _vm.editDialog.form.currency,
                                  no: "17"
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.editDialog.form.currency = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.ContainerSize")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames.local_cache_EQSize,
                                  filterable: "",
                                  "default-value": _vm.editDialog.form.eqSize,
                                  no: "18"
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.editDialog.form.eqSize = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.ContainerType")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_EQType,
                                  filterable: "",
                                  "default-value": _vm.editDialog.form.eqType,
                                  no: "19"
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.editDialog.form.eqType = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              class: _vm.variableCss.quantity,
                              attrs: { label: _vm.$t("SeaExport.Quantity2") }
                            },
                            [
                              _c("el-input-number", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  precision: 0,
                                  controls: false,
                                  no: "20"
                                },
                                on: { change: _vm.caculateAmount },
                                model: {
                                  value: _vm.editDialog.form.quantity,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.editDialog.form,
                                      "quantity",
                                      $$v
                                    )
                                  },
                                  expression: "editDialog.form.quantity"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("SeaExport.UnitRate") } },
                            [
                              _c("el-input-number", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  precision: 2,
                                  controls: false,
                                  no: "21"
                                },
                                on: { change: _vm.caculateAmount },
                                model: {
                                  value: _vm.editDialog.form.unitRate,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.editDialog.form,
                                      "unitRate",
                                      $$v
                                    )
                                  },
                                  expression: "editDialog.form.unitRate"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("SeaExport.Amount") } },
                            [
                              _c("el-input-number", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  precision: 2,
                                  controls: false,
                                  no: "22"
                                },
                                on: {
                                  change: function($event) {
                                    _vm.editDialog.form.unitRate =
                                      _vm.editDialog.form.amount
                                  }
                                },
                                model: {
                                  value: _vm.editDialog.form.amount,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editDialog.form, "amount", $$v)
                                  },
                                  expression: "editDialog.form.amount"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "span",
                    { attrs: { slot: "footer" }, slot: "footer" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "23" },
                          on: { click: _vm.save }
                        },
                        [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { no: "24" },
                          on: {
                            click: function($event) {
                              _vm.editDialog.visible = false
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                      )
                    ],
                    1
                  )
                ]
              ),
              _c("match-history-dialog", {
                attrs: {
                  visible: _vm.matchHistoryDialog.visible,
                  "cargo-doc-uuid": _vm.form.uuid
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(_vm.matchHistoryDialog, "visible", $event)
                  }
                }
              }),
              _c("trade-detail-window", {
                attrs: {
                  visible: _vm.tradeDetailDialog.visible,
                  "cargo-doc": _vm.form,
                  "container-info": _vm.tradeDetailDialog.containerInfo
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(_vm.tradeDetailDialog, "visible", $event)
                  },
                  callBackFun: _vm.reloadEDIContainer
                }
              })
            ],
            1
          ),
          _c("cargo-cloud-file-upload", {
            attrs: {
              visible: _vm.cloudFile.visible,
              job: _vm.cloudFile.job,
              lob: _vm.cloudFile.lob,
              "file-size": _vm.cloudFile.fileSize,
              "file-category": _vm.cloudFile.fileCategory,
              "file-category-label": _vm.cloudFile.fileCategoryLabel,
              "upload-source": _vm.cloudFile.uploadSource,
              "other-param": _vm.cloudFile.otherParam
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.cloudFile, "visible", $event)
              },
              uploadDone: _vm.onUploadDone
            }
          }),
          _c(
            "el-dialog",
            {
              attrs: {
                visible: _vm.checkTheBLLog.visible,
                title: _vm.$t("SeaExport.CheckTheBLCenterApiLog"),
                width: "1000px",
                "close-on-click-modal": false,
                "destroy-on-close": true,
                top: "5vh",
                "custom-class": "details-view settlement-notice"
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.checkTheBLLog, "visible", $event)
                }
              }
            },
            [
              _c("div", { staticClass: "main-content" }, [
                _c(
                  "div",
                  { staticClass: "section grid-wrapper" },
                  [
                    _c("cargo-ag-grid", {
                      attrs: {
                        "grid-params": _vm.checkTheBLLog.gridParams,
                        "grid-options": _vm.checkTheBLLog.gridOptions,
                        "column-defs": _vm.checkTheBLLog.columnDefs,
                        "row-data": _vm.checkTheBLLog.rowData
                      },
                      on: {
                        "update:gridParams": function($event) {
                          return _vm.$set(
                            _vm.checkTheBLLog,
                            "gridParams",
                            $event
                          )
                        },
                        "update:grid-params": function($event) {
                          return _vm.$set(
                            _vm.checkTheBLLog,
                            "gridParams",
                            $event
                          )
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ]
          ),
          _c("xhq-overseas-agent-feedback-dialog", {
            attrs: {
              visible: _vm.xhqOverseasAgentFeedbackDialog.visible,
              data: _vm.xhqOverseasAgentFeedbackDialog.data,
              callback: _vm.xhqOverseasAgentFeedbackDialog.callback
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(
                  _vm.xhqOverseasAgentFeedbackDialog,
                  "visible",
                  $event
                )
              }
            }
          }),
          _c("guarantee-file-dialog", {
            attrs: {
              visible: _vm.guaranteeFileDialog.visible,
              model: _vm.guaranteeFileDialog.model,
              title: _vm.$t("Message.fileManagement")
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.guaranteeFileDialog, "visible", $event)
              }
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }